/* import __COLOCATED_TEMPLATE__ from './translations-upload.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ENV from 'bullitt-time-gochips/config/environment';

export default class TranlationsListUploadComponent extends Component 
{
	@service store;
	
	@tracked shouldUpdate = true;
	@tracked shouldInsert = true;
	@tracked shouldDrop = false;
	
	@tracked updated = "";
	@tracked inserted = "";
	@tracked dropped = "";
	@tracked errors = {};
	
	@action
	toggleShouldInsert(event)
	{
		this.shouldInsert = event.target.checked;
	}
	
	@action
	toggleShouldUpdate(event)
	{
		this.shouldUpdate = event.target.checked;
	}
	
	@action
	toggleShouldDrop(event)
	{
		this.shouldDrop = event.target.checked;
	}
	
	@action
	async uploadFile(file)
	{
		var that = this;
		var url = ENV.gochipsBackendProtocol+"://"+ENV.gochipsBackendHost+":"+ENV.gochipsBackendPort+(ENV.gochipsBackendNamespace ? "/"+ENV.gochipsBackendNamespace : "")+"/uploadTranslations"
		const responseStream = await file.upload(url,
		{
			data:
			{ 
				'update': this.shouldUpdate,
				'insert': this.shouldInsert,
				'drop': this.shouldDrop, 
			}
		});
		const reader = responseStream.body.getReader();
		let response = await reader.read();
		response = new TextDecoder().decode(response.value);
		response = JSON.parse(response);
		
		const translations = that.store.peekAll('Translation');
		translations.forEach((modelInstance) => modelInstance.unloadRecord());
		
		that.inserted = response.numRecordsInserted;
		that.updated = response.numRecordsUpdated;
		that.dropped = response.numRecordsDropped;
		that.errors = response.errors;
	}
}
